// These must match the server
export enum RunGroupID {
    OAuthFlow = "OAuthFlow",
    PersistCreds = "PersistCreds",
    Reregister = "Reregister",
    RevokeToken = "RevokeToken",
    MQTTBackoff = "MQTTBackoff",
	MQTTPersist = "MQTTPersist",
    MQTTReconnect = "MQTTReconnect",
    Network = "Network",
    MessageValidation = "MessageValidation",
};